import { Box, Container, List, Stack, Text } from "@chakra-ui/react";
import Head from "next/head";

import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const AvisoAClientes = () => {
    return (
        <>
            <Head>
                <title>Aviso a Clientes | Grupo Guía</title>
                <link rel="canonical" href="https://grupoguia.mx/aviso-a-clientes" />
                <link
                    rel="alternate"
                    href="https://grupoguia.mx/aviso-a-clientes"
                    hreflang="es-mx"
                />
            </Head>
            <Header />
            <Container maxWidth={{ base: "7xl", md: "8xl" }} pt={{ base: 14, md: 24 }}>
                <Box
                    pb={20}
                    minHeight="100vh"
                    mt={16}
                    maxW={{ base: "100%", md: "80%" }}
                    mx="auto"
                    px={{ base: 4, sm: 6, md: 8, lg: 12, xl: 16 }}
                >
                    <Stack>
                        <Text
                            fontSize={{ md: "2xl", base: "xl" }}
                            align="center"
                            color="accent.500"
                            fontWeight="700"
                        >
                            AVISO IMPORTANTE A NUESTROS CLIENTES Y PÚBLICO EN GENERAL
                        </Text>
                    </Stack>
                    <Stack my={4}>
                        <Text
                            fontSize={{ md: "lg", base: "sm" }}
                            align="center"
                            color="accent.500"
                            fontWeight={400}
                            pb={2}
                        >
                            En{" "}
                            <Text fontWeight={600} as="span" color="#f6cb07">
                                GUIA EXCELENCIA INMOBILIARIA, S.A. DE C.V.
                            </Text>
                            , reiteramos nuestro compromiso con la transparencia, la legalidad y la
                            seguridad de nuestros clientes.
                            <br /> <br />
                            <strong>Informamos que:</strong>
                            <br /> <br />
                            <List.Root ml={8} pb={4}>
                                <List.Item>
                                    Nuestra empresa no comercializa propiedades bajo esquemas
                                    distintos a los publicados en nuestro sitio web oficial:{" "}
                                    <Text fontWeight={600} as="span" color="#f6cb07">
                                        www.grupoguia.mx
                                    </Text>
                                </List.Item>
                                <List.Item>
                                    No manejamos ninguna línea de negocio relacionada con la venta
                                    de tiempos compartidos.
                                </List.Item>
                                <List.Item>
                                    No ofrecemos ni operamos esquemas de renta vacacional en ninguna
                                    ciudad del país.
                                </List.Item>
                                <List.Item>
                                    El único inventario que forma parte de nuestro portafolio es el
                                    publicado en nuestro sitio web oficial{" "}
                                    <Text fontWeight={600} as="span" color="#f6cb07">
                                        www.grupoguia.mx
                                    </Text>
                                </List.Item>
                            </List.Root>
                            <br />
                            <Text fontWeight={600} as="span" color="#f6cb07">
                                GUIA EXCELENCIA INMOBILIARIA, S.A. DE C.V.
                            </Text>{" "}
                            no recibe, en ningún caso y bajo ningún supuesto,{" "}
                            <Text fontWeight={600} as="span" textDecoration="underline">
                                cantidad alguna de dinero relacionada con la venta o renta de
                                propiedades
                            </Text>
                            , ya sea de manera directa o indirecta.
                            <br /> <br />
                            Todos los pagos y transacciones deben realizarse únicamente conforme a
                            lo establecido en nuestra página oficial o en los contratos de
                            comercialización, los cuales nunca permiten la transferencia de dinero
                            directa a GUIA ni a sus asesores.
                            <br /> <br />
                            Todos nuestros promotores cuentan con una{" "}
                            <Text fontWeight={600} as="span" textDecoration="underline">
                                credencial oficial que los acredita como personal autorizado
                            </Text>
                            . Usted puede solicitar dicha identificación directamente al promotor y,
                            si así lo desea, confirmar su validez a través de nuestros canales de
                            atención:
                            <br /> <br />
                            <strong>Correo electrónico:</strong>{" "}
                            <Text fontWeight={600} as="span" color="#f6cb07">
                                atencionaclientes@grupoguia.mx
                            </Text>
                            <br /> <br />
                            <strong>WhatsApp:</strong>{" "}
                            <Text fontWeight={600} as="span" color="#f6cb07">
                                33 1868 1590
                            </Text>
                            <br /> <br />
                            Si usted ha sido contactado o le han ofrecido alguna propiedad distinta
                            y en términos diferentes a los que se muestran en nuestra página web, le
                            pedimos por favor reportarlo a través del correo antes mencionado.
                            <br /> <br />
                            Agradecemos su atención y los invitamos a verificar cualquier
                            información directamente con nosotros. Su confianza es lo más importante
                            para nosotros.
                        </Text>
                    </Stack>
                </Box>
            </Container>
            <Footer esGuiaRent={false} />
        </>
    );
};

export default AvisoAClientes;
